module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.8a048451.woff2";